import React from 'react';
import './legal-pages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <header className="legal-header">
          <h1>プライバシーポリシー</h1>
          <p className="last-updated">最終更新日：2024年8月16日</p>
        </header>

        <div className="legal-body">
          <section className="legal-section">
            <h2>1. 基本方針</h2>
            <p>
              生成AI Boost LMS（以下「当サービス」）は、ユーザーの個人情報を適切に保護することを重要な責務と考え、
              個人情報保護法その他の関連法令等を遵守し、個人情報の適正な取り扱いに努めます。
            </p>
          </section>

          <section className="legal-section">
            <h2>2. 個人情報の定義</h2>
            <p>
              本プライバシーポリシーにおける「個人情報」とは、個人情報保護法第2条第1項に定義される
              「個人情報」を指します。すなわち、生存する個人に関する情報であって、当該情報に含まれる
              氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と
              容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）を指します。
            </p>
          </section>

          <section className="legal-section">
            <h2>3. 収集する個人情報</h2>
            <p>当サービスでは、以下の個人情報を収集する場合があります：</p>
            <ul>
              <li><strong>基本情報：</strong>氏名、メールアドレス、プロフィール画像</li>
              <li><strong>SNS連携情報：</strong>LINEアカウント情報、Google アカウント情報、Facebookアカウント情報</li>
              <li><strong>学習履歴：</strong>コース進捗、視聴履歴、テスト結果、学習時間</li>
              <li><strong>デバイス情報：</strong>IPアドレス、ブラウザ情報、端末情報</li>
              <li><strong>ログ情報：</strong>アクセス日時、利用状況、操作履歴</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. 個人情報の利用目的</h2>
            <p>収集した個人情報は、以下の目的で利用いたします：</p>
            <ul>
              <li>サービスの提供、運営、維持、改善</li>
              <li>ユーザーアカウントの管理</li>
              <li>学習進捗の記録・管理・通知</li>
              <li>カスタマーサポートの提供</li>
              <li>重要なお知らせ・メンテナンス情報の通知</li>
              <li>利用規約違反の対応</li>
              <li>サービスの利用状況の分析・統計処理</li>
              <li>新機能・サービスに関する情報提供</li>
              <li>法令に基づく対応</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. 個人情報の第三者提供</h2>
            <p>
              当サービスは、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者に提供することはありません。
              ただし、以下の場合には第三者提供を行う場合があります：
            </p>
            <ul>
              <li>法令に基づく場合</li>
              <li>人の生命、身体または財産の保護のために必要がある場合</li>
              <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
              <li>国の機関等への協力のために特に必要がある場合</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. 個人情報の共同利用</h2>
            <p>
              当サービスでは、サービス向上のため、以下の範囲で個人情報の共同利用を行う場合があります：
            </p>
            <ul>
              <li><strong>共同利用する個人情報の項目：</strong>学習履歴、利用状況（個人を特定できない統計情報として）</li>
              <li><strong>共同利用者の範囲：</strong>サービス提供に関わる協力企業</li>
              <li><strong>利用目的：</strong>サービスの向上・機能改善</li>
              <li><strong>管理責任者：</strong>生成AI Boost LMS 運営事務局</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. 個人情報の安全管理</h2>
            <p>
              当サービスでは、個人情報の漏洩、滅失または毀損の防止その他の個人情報の安全管理のために、
              適切な安全保護措置を講じます：
            </p>
            <ul>
              <li>SSL/TLS暗号化通信の使用</li>
              <li>アクセス権限の適切な管理</li>
              <li>定期的なセキュリティ監査の実施</li>
              <li>従業員への個人情報保護に関する教育</li>
              <li>不正アクセス対策の実施</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. 個人情報の保存期間</h2>
            <p>
              個人情報は、利用目的の達成に必要な期間に限り保存します。
              アカウント削除後は、法令で定められた保存義務がある場合を除き、
              遅滞なく個人情報を削除いたします。
            </p>
          </section>

          <section className="legal-section">
            <h2>9. ユーザーの権利</h2>
            <p>ユーザーは、自己の個人情報について以下の権利を有します：</p>
            <ul>
              <li><strong>開示請求権：</strong>個人情報の利用状況を確認する権利</li>
              <li><strong>訂正・追加・削除請求権：</strong>個人情報の訂正等を求める権利</li>
              <li><strong>利用停止・消去請求権：</strong>個人情報の利用停止等を求める権利</li>
              <li><strong>第三者提供停止請求権：</strong>第三者への提供停止を求める権利</li>
            </ul>
            <p>これらの権利行使に関するお問い合わせは、下記窓口までご連絡ください。</p>
          </section>

          <section className="legal-section">
            <h2>10. Cookie等の利用</h2>
            <p>
              当サービスでは、サービスの利便性向上のため、Cookie及び類似技術を使用します。
              これらの技術により、ユーザーの利用状況を分析し、よりよいサービス提供に努めます。
              Cookieの無効化は、ブラウザの設定から行うことができますが、
              サービスの一部機能が利用できなくなる場合があります。
            </p>
          </section>

          <section className="legal-section">
            <h2>11. アクセス解析ツール</h2>
            <p>
              当サービスでは、サービス向上のため、Google Analytics等の
              アクセス解析ツールを使用する場合があります。
              これらのツールでは、Cookie等を用いてユーザーの行動を分析しますが、
              個人を特定する情報は含まれません。
            </p>
          </section>

          <section className="legal-section">
            <h2>12. 未成年者の個人情報</h2>
            <p>
              当サービスでは、15歳未満の方の個人情報を収集する場合には、
              保護者の同意を得るものとします。保護者の方は、お子様の個人情報について、
              開示・訂正・削除等を請求することができます。
            </p>
          </section>

          <section className="legal-section">
            <h2>13. プライバシーポリシーの変更</h2>
            <p>
              本プライバシーポリシーは、法令の改正やサービス内容の変更に伴い、
              予告なく変更する場合があります。重要な変更がある場合には、
              サービス内での通知またはメール等により事前にお知らせいたします。
              変更後のプライバシーポリシーは、当サービスに掲載した時点から効力を生じるものとします。
            </p>
          </section>

          <section className="legal-section">
            <h2>14. お問い合わせ窓口</h2>
            <p>個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください：</p>
            <div className="contact-info">
              <p><strong>生成AI Boost LMS 運営事務局</strong></p>
              <p>メールアドレス：<a href="mailto:privacy@geneaiboost.com">privacy@geneaiboost.com</a></p>
              <p>受付時間：平日 9:00-18:00（土日祝日・年末年始を除く）</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>15. 準拠法・管轄裁判所</h2>
            <p>
              本プライバシーポリシーの解釈及び適用については日本法が適用され、
              当サービスの個人情報の取り扱いに関する紛争については、
              東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <p>以上</p>
          <p className="company-name">生成AI Boost LMS 運営事務局</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;